import React from "react";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import ModalClose from "@mui/joy/ModalClose";
import DialogTitle from "@mui/joy/DialogTitle";
import DialogContent from "@mui/joy/DialogContent";
import Button from "@mui/joy/Button";
import API_BASE_URL from "../../../../../config/config.js";
import axios from "axios";

const AdminOptionsModal = ({
  open,
  onClose,
  equipos,
  idevent,
  idsport,
  toast,
  getPeriodBySport,
  fechasGrupo,
  configData,
}) => {
  const handleGenerarFixture = async () => {
    try {
      const response = await axios.post(`${API_BASE_URL}/postfixture`, {
        equipos: equipos,
        idevent: idevent,
        idsport: idsport,
      });
      console.log("response", response);
      toast.success("¡Fixture Generado Exitosamente!");
      onClose();
    } catch (error) {
      toast.error("¡Hubo un error en la generación del Fixture!");
      console.error("Error al generar el fixture", error);
    }
  };

  const handleGenerarPeriodos = async () => {
    try {
      const response = await axios.post(`${API_BASE_URL}/postperiods`, {
        idevent: Number(idevent),
        idsport: Number(idsport),
        idtypephase: 1,
        nroperiodos: Number(idevent) === 1 && (Number(idsport) === 16 || Number(idsport) === 17) ? 5 : getPeriodBySport(Number(idsport)),
      });
      toast.success("¡Periodos Generados Exitosamente!");
      onClose();
    } catch (error) {
      toast.error("¡Hubo un error en la generación de los Periodos!");
      console.error("Error al generar los Periodos", error);
    }
  };

  const handleGenerarPosicionesFecha = async () => {
    try {
      const response = await axios.post(`${API_BASE_URL}/getparticipants`, {
        idevent: Number(idevent),
        idsport: Number(idsport),
        idtypephase: 1,
      });
      console.log("Participantes", response.data);

      const participantes = response.data;
      const grupos = {};

      participantes.forEach((participante) => {
        const grupo = participante.idgrupo;
        if (!grupos[grupo]) {
          grupos[grupo] = [];
        }
        grupos[grupo].push(participante);
      });

      console.log("grupos", grupos);

      const posiciones = [];
      Object.keys(grupos).forEach((idgrupo) => {
        const grupo = grupos[idgrupo];

        grupo.sort((a, b) => a.nro_grupo - b.nro_grupo);

        grupo.forEach((participante, index) => {
          posiciones.push({
            idevent: Number(idevent),
            idsport: Number(idsport),
            fechas_total: fechasGrupo,
            nro_fecha: 0,
            idgrupo: Number(idgrupo),
            posicion: participante.nro_grupo,
            idparticipant: participante.idparticipant,
            direccion: 1,
            pts: 0,
            pj: 0,
            g: 0,
            e: 0,
            p: 0,
            wo: 0,
            pf: 0,
            pc: 0,
            dp: 0,
            pg2_0: 0,
            pg2_1: 0,
            pp2_0: 0,
            pp2_1: 0,
            ratioSet: 0.0,
            ratioPuntos: 0.0,
            f1: 0,
            f2: 0,
            f3: 0,
            f4: 0,
            f5: 0,
            f6: 0,
            f7: 0,
            f8: 0,
            f9: 0,
            //->
            pg3_0: 0,
            pg3_1: 0,
            pg3_2: 0,
            pp3_0: 0,
            pp3_1: 0,
            pp3_2: 0,
            di: 2000,
            //->
            state: 1,
          });
        });
      });

      await axios.post(`${API_BASE_URL}/postposicionesfecha`, posiciones);

      toast.success("¡Posiciones Generadas Exitosamente!");
    } catch (error) {
      toast.error("¡Hubo un error en la generación de las Posiciones!");
      console.error("Error al generar las Posiciones", error);
    }
  }

  const handleGenerarPosiciones = async () => {
    try {
      const response = await axios.post(`${API_BASE_URL}/getparticipants`, {
        idevent: Number(idevent),
        idsport: Number(idsport),
        idtypephase: 1,
      });
      console.log("Participantes", response.data);

      const participantes = response.data;
      const grupos = {};

      participantes.forEach((participante) => {
        const grupo = participante.idgrupo;
        if (!grupos[grupo]) {
          grupos[grupo] = [];
        }
        grupos[grupo].push(participante);
      });

      console.log("grupos", grupos);

      const posiciones = [];
      Object.keys(grupos).forEach((idgrupo) => {
        const grupo = grupos[idgrupo];

        grupo.sort((a, b) => a.nro_grupo - b.nro_grupo);

        grupo.forEach((participante, index) => {
          posiciones.push({
            idevent: Number(idevent),
            idsport: Number(idsport),
            fechas_total: fechasGrupo,
            nro_fecha: 0,
            idgrupo: Number(idgrupo),
            posicion: participante.nro_grupo,
            idparticipant: participante.idparticipant,
            direccion: 1,
            pts: 0,
            pj: 0,
            g: 0,
            e: 0,
            p: 0,
            wo: 0,
            pf: 0,
            pc: 0,
            dp: 0,
            pg2_0: 0,
            pg2_1: 0,
            pp2_0: 0,
            pp2_1: 0,
            ratioSet: 0.0,
            ratioPuntos: 0.0,
            f1: 0,
            f2: 0,
            f3: 0,
            f4: 0,
            f5: 0,
            f6: 0,
            f7: 0,
            f8: 0,
            f9: 0,
            //->
            pg3_0: 0,
            pg3_1: 0,
            pg3_2: 0,
            pp3_0: 0,
            pp3_1: 0,
            pp3_2: 0,
            di: 2000,
            //->
            state: 1,
          });
        });
      });

      await axios.post(`${API_BASE_URL}/postposiciones`, posiciones);

      toast.success("¡Posiciones Generadas Exitosamente!");
    } catch (error) {
      toast.error("¡Hubo un error en la generación de las Posiciones!");
      console.error("Error al generar las Posiciones", error);
    }
  };

  const handleGenerarAcumulados = async () => {
    try {
      const response = await axios.post(`${API_BASE_URL}/config_category`, {
        idevent: Number(idevent),
        idsport: Number(idsport),
      });
      console.log("Config", response.data);

      const config = response.data;

      const nroGrupos = config.nro_grupos;
      const nroInstitucionesParticipantes =
        config.nro_instituciones_participantes;
      const posicionesTotales =
        nroGrupos * (nroInstitucionesParticipantes / nroGrupos); // 24 en tu ejemplo

      const acumulados = [];

      for (let i = 0; i < posicionesTotales; i++) {
        let idgrupo =
          Math.floor(i / (nroInstitucionesParticipantes / nroGrupos)) + 1;
        let nivel_acumulado = Math.floor(i / nroGrupos) + 1;

        acumulados.push({
          idevent: Number(idevent),
          idsport: Number(idsport),
          idgrupo: idgrupo,
          idparticipant: null, // De momento null
          posicion: i + 1,
          nivel_acumulado: nivel_acumulado,
          isClasificado: i < 16, // Los primeros 16 clasificados
          posicionLimiteClasificacion: 17, // Límite de clasificación
          state: 1, // Estado inicial
        });
      }
      console.log("acumulados", acumulados);

      // Aquí enviarías la data a tu API
      const saveResponse = await axios.post(
        `${API_BASE_URL}/postacumulados`,
        acumulados
      );
      console.log("Acumulados generados y guardados:", saveResponse.data);
      toast.success("¡Acumulados generados exitosamente!");
    } catch (error) {
      toast.error("Hubo un error al momento de crear la tabla de acumulados");
      console.error("Error al momento de crear acumulados", error);
    }
  };

  const handleUpdateMatchesGroupsSkeleton = async () => {
    try {
      const response = await axios.patch(
        `${API_BASE_URL}/updaterelationgroupsmatches`,
        {
          idevent: Number(idevent),
          idsport: Number(idsport),
        }
      );
      toast.success("¡Matches Actualizados Correctamente!");
      console.log("res data", response.data);
    } catch (error) {
      toast.error("¡Error al Actualizar!");
      console.error("Error Match Skeleton", error);
    }
  }

  const handleRelationMatchesSkeleton = async () => {
    try {
      const response = await axios.patch(
        `${API_BASE_URL}/updatematchskeleton`,
        {
          idevent: Number(idevent),
          idsport: Number(idsport),
          idtypephase: 1,
        }
      );
      toast.success("¡Relacionados Correctamente!");
      console.log("res data", response.data);
    } catch (error) {
      toast.error("¡Error al Relacionar!");
      console.error("Error Match Skeleton", error);
    }
  };

  const handleCreateMatchesFinalRelationSkeleton = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/creatematchesskeleton`,
        {
          idevent: Number(idevent),
          idsport: Number(idsport),
          idtypephase: 2,
        }
      );
      toast.success("¡Matches Fase Final Creados!");
      console.log("res data", response.data);
    } catch (error) {
      toast.error("¡Error al Crear!");
      console.error("Error Match Skeleton", error);
    }
  };



  const handleCreateMatchesColectiveExpressSkeleton = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/creatematchesskeletoncolectiveexpress`,
        {
          idevent: Number(idevent),
          idsport: Number(idsport),
        }
      );
      toast.success("¡Matches Creados!");
      console.log("res data", response.data);
    } catch (error) {
      toast.error("¡Error al Crear!");
      console.error("Error Match Skeleton", error);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog>
        <ModalClose />
        <DialogTitle>Opciones Avanzadas (SOLO SUPERADMINISTRADOR)</DialogTitle>
        <DialogContent>
          <div className="flex flex-col gap-4">
            <Button variant="solid" onClick={handleGenerarFixture}>
              Generar el Fixture de la Categoría
            </Button>
            <Button variant="solid" onClick={handleGenerarPeriodos}>
              Generar Periodos de los Match
            </Button>
            <Button variant="solid" onClick={handleGenerarPosiciones}>
              Generar Tabla de Posiciones
            </Button>
            <Button variant="solid" onClick={handleGenerarPosicionesFecha}>
              Generar Tabla de Posiciones por Fecha
            </Button>
            <Button variant="solid" onClick={handleGenerarAcumulados}>
              Generar Tabla de Acumulados
            </Button>
            <Button variant="solid" onClick={handleRelationMatchesSkeleton}>
              Fase de Grupos: Relacionar Matches con Esqueleto
            </Button>
            <Button
              variant="solid"
              onClick={handleCreateMatchesFinalRelationSkeleton}
            >
              Fase Final: Crear Matches con Esqueleto
            </Button>
            <Button
              variant="solid"
              onClick={handleCreateMatchesColectiveExpressSkeleton}
            >
              Crear Matches para Colectivos Express según Esqueleto
            </Button>
            <Button
              variant="solid"
              onClick={handleUpdateMatchesGroupsSkeleton}
            >
              Actualizar Matches segun Grupo y Esqueleto
            </Button>
          </div>
        </DialogContent>
      </ModalDialog>
    </Modal>
  );
};

export default AdminOptionsModal;
